import { id } from '../id.mjs';

const assertIsRefWrapper = {
    "ref": id(undefined),
};

export { assertIsRefWrapper };
//# sourceMappingURL=assertIsRefWrapper.mjs.map
